module.exports = __webpack_public_path__ + "static/media/curatedSearchDot.790a860b.svg";